import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
  FormControl,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Cancel } from '../../media/images/Cancel';
import { AnalystTubeCountDatatablestyle } from './utils/Constant';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import { getVesselMasterStart } from '../Job/ScreenUnitInformation/redux/unitInfoSlice';
import ComponentSelectInput from '../../Common/ComponentSelectInput';
import { renameVesselStart } from '../VesselInformation/redux/VesselMainRedux/vesselMainSlice';
import ConfirmationModal from '../../Common/ConfirmationModal/ConfirmationModal';
import { ConfirmationIcon } from '../../assets/Icons/AnalystIcons/ConfirmationIcon';

interface IAnalystTubeCountModal {
  open: boolean;
  handleClose: () => void;
}

export default function VesselRenameModal({
  open, handleClose,
}: IAnalystTubeCountModal) {
  const dispatch = useDispatch();
  const { jobOrderId, vesselId } = useParams();

  const { isLoading, vesselMaster } = useSelector((state: RootState) => state.unitInfoReducer);
  const { vesselData, isLoading: isUpdating } = useSelector((state: RootState) => state.VesselMainReducer);
  const { control } = useForm();

  useEffect(() => {
    dispatch(getVesselMasterStart());
  }, []);

  useEffect(() => {
    if (isLoading || isUpdating) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [isLoading, isUpdating]);

  const [vesselName, setVesselName] = useState('');
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const handleChange = (val: string) => {
    setVesselName(val);
  };

  const closeModal = () => {
    setVesselName('');
    handleClose();
  };
  const isButtonEnabled = useMemo(() => vesselName?.length > 0, [vesselName]);
  const entries = useMemo(() => {
    if (vesselMaster?.length > 0) {
      const filtered = vesselMaster?.filter((items) => (items?.VesselType?.toLowerCase() === 'normal'));
      const idsToBeRemoved = vesselData?.map((item) => item?.Value);
      const removedVesselsArray = filtered?.filter((item) => !(idsToBeRemoved?.includes(String(item?.Id))));
      const reOrdered = removedVesselsArray?.map((i) => ({
        Text: i?.VesselName,
        Value: String(i?.Id),
      }));
      return reOrdered;
    }
    return [];
  }, [vesselMaster]);

  const callback = () => {
    window.location.href = `/vessel-information/${jobOrderId}/${vesselName}`;
    closeModal();
  };

  const handleSave = () => {
    const payload = {
      pay: {
        JobOrder: jobOrderId,
        VesselId: Number(vesselId),
        NewVesselId: Number(vesselName),
      },
      callback,
    };
    dispatch(renameVesselStart(payload));
  };

  return (
    <>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={AnalystTubeCountDatatablestyle}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Rename Vessel
            </div>
            <div className="cancel-icon" onClick={() => closeModal()}>
              <Cancel />
            </div>

          </div>
          <div className="analystTubeCountModalHeaderRowAlign">
            <FormControl sx={{
              width: 340,
              marginTop: '-20px',
            }}
            >
              <p className="renameVesselModalLabel">Select Vessel</p>
              <ComponentSelectInput
                name="vessel"
                control={control}
              // errors={errors}
                handleChange={handleChange}
                size="small"
                entries={entries || []}
                searchable
              />
            </FormControl>
            <Button
              className={isButtonEnabled ? 'button_save_and_next' : 'button_cancel cursorNotAllowed'}
              sx={{ height: 36, marginTop: '20px' }}
              onClick={() => setOpenConfirmation(true)}
            >
              Update Vessel Name
            </Button>
          </div>
        </Box>
      </Modal>
      <ConfirmationModal
        show={openConfirmation}
        setOpenFrom={() => setOpenConfirmation(false)}
        confirmationIcon={<ConfirmationIcon />}
        text="The vessel name will be updated across all linked modules. Are you sure you want to proceed with updating the vessel name?"
        handleConfirmation={handleSave}
        closeBtnText="Abort"
        proceedBtnText="Proceed"
      />
    </>
  );
}
